import * as $ from "jquery";

function initFavoritesDisplay() {
	let $favoritesLink = $('.js-favorites').find('a');
	$favoritesLink.append('<span class="js-favorites-count">(0)</span>');

	updateFavoritesCount();

	$(window).on('favorites', function() {
		updateFavoritesCount();
	});
}

function updateFavoritesCount() {
	let $favoritesDisplay = $('.js-favorites-count');

	if (localStorage.getItem('favorites')) {
		let productIds = JSON.parse(localStorage.getItem('favorites'));
		let favoriteCount = 0;

		if (Array.isArray(productIds)) {
			favoriteCount = productIds.length;
		}

		$favoritesDisplay.text(` (${favoriteCount})`);
	}
}

export function init() {
	initFavoritesDisplay();
}


// WEBPACK FOOTER //
// ./js/PFF/modules/favoritesDisplay.ts